<template>
  <div>
    <Clients
      v-if="$route.params.filter_by == 'clients'"
      @firstLoadDone="firstLoadDone"></Clients>

    <Members
      v-if="$route.params.filter_by == 'members'"
      @firstLoadDone="firstLoadDone"></Members>

    <Teams
      v-if="$route.params.filter_by == 'teams'"
      @firstLoadDone="firstLoadDone"></Teams>

  </div> <!-- dvContent -->
</template>

<script>
  import Clients from '@/components/search/Clients.vue'
  import Members from '@/components/search/Members.vue'
  import Teams from '@/components/search/Teams.vue'

  export default {
    name: 'search-result-main',
    data: () => ({
      q: '',
      firstLoad: true,
    }),
    watch: {
      $route (to, from){
        let q = to.query.q
        this.q = q
        this.firstLoad = true        
      }
    },
    computed: {
    },
    methods: {
      firstLoadDone (){
        this.firstLoad = false
      }
    },
    mounted() {
      this.q = this.$route.query.q
    },
    components: {
      Clients,
      Members,
      Teams
    }
  }
</script>
